import { fetchAiResult, fetchAiResultCustom, } from 'api/model/services/services-api';
const handleDefaultAi = async (context) => {
    const { connection, projectIds, language, begin, end, isCustom, assignment, customPrompt, result, createNewProject, trsxLabel, logger, } = context;
    if (isCustom === true) {
        return fetchAiResultCustom(connection, [customPrompt !== null && customPrompt !== void 0 ? customPrompt : ''], projectIds, begin, end, undefined, trsxLabel);
    }
    if (assignment === undefined) {
        logger.info('No assignment selected');
        return null;
    }
    return fetchAiResult(connection, projectIds, language.code, assignment.name, assignment.scopeKind, begin, end, undefined, undefined, result, createNewProject, trsxLabel);
};
const handleAiTranslate = async (context) => {
    const { connection, projectIds, language, begin, end, logger, translateAssignment, createNewProject, trsxLabel, } = context;
    if (translateAssignment === undefined) {
        logger.info('Translate assignment not found');
        return null;
    }
    return fetchAiResult(connection, projectIds, language.code, translateAssignment.name, translateAssignment.scopeKind, begin, end, undefined, undefined, 'StreamedProject', createNewProject, trsxLabel);
};
// NOTE: Add new specific prompt handlers here
export const PROMPT_HANDLERS = {
    Translation: handleAiTranslate,
};
const getPromptHandler = (prompt) => {
    if (prompt !== null) {
        return PROMPT_HANDLERS[prompt];
    }
    return handleDefaultAi;
};
export const handlePrompt = async (prompt, context) => {
    const handler = getPromptHandler(prompt);
    return handler(context);
};
